<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">修改会议</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <el-form-item label="所属公司">
            <el-select size="small" class="organization-select" v-model="form.depId" placeholder="请选择所属公司">
              <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会议名称/简介">
            <el-col :span="10">
              <el-input size="small" v-model="form.name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="会议地点">
            <el-select size="small" v-model="form.roomId" placeholder="请选择会议地点">
              <el-option v-for="item in meetingRoomData" :key="item.id" :label="item.address" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>


          <el-row>
            <el-col :span="10">
              <el-form-item label="*会议时间">
                <el-date-picker style="width:100%!important;" v-model="form.conferenceTime" size="small"
                  value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择会议日期时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="*预计会议时间">
                <el-input style="width:100px;" size="small" type="number" v-model="form.useTime"></el-input>
                &nbsp;&nbsp;分钟
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-form-item label="会议时间">
            <el-date-picker v-model="form.conferenceTime" size="small" value-format="yyyy-MM-dd HH:mm" type="datetime"
              placeholder="选择会议日期时间">
            </el-date-picker>
          </el-form-item> -->

          <el-form-item label="会议要求">
            <el-col :span="18">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入会议要求" v-model="form.req">
              </el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="参会人员">
            <div class="contact-user-list">
              <div class="user-item" v-for="user,i in selectArr">
                <span class="name">{{user.name}}</span>
                <span @click="deleteUsers(1,i)" class="iconfont icon-close1"></span>
              </div>
            </div>
            <el-button @click="addUsers(1)" icon="el-icon-plus" size="small" type="primary" plain>添加参会人员</el-button>
          </el-form-item>

          <div class="clear">
            <el-form-item label="会议资料/附件">
              <attachments style="margin-left:-15px;" :projectId="form.projectId" :contractId="form.contractId"
                ref="attachments" :arr="attachmentArr" :type='995'></attachments>
            </el-form-item>
          </div>

          <el-form-item label="会议准备">
            <el-checkbox v-model="isForm2">是否需要会议准备</el-checkbox>
            <div v-if="isForm2" style="padding:10px;border:1px #ccc solid;border-radius:5px;">
              <div class="clear">
                <el-checkbox v-model="form2.isHaveCamera">摄像</el-checkbox>
                <el-checkbox v-model="form2.isHaveTea">茶水</el-checkbox>
                <el-checkbox v-model="form2.isHaveEat">就餐</el-checkbox>
                <el-checkbox v-model="form2.isHaveProjector">投影</el-checkbox>
              </div>
              <div class="clear">
                <el-checkbox v-model="form2.isHaveSeat">座位牌</el-checkbox>
                <el-input type="textarea" v-if="form2.isHaveSeat" size="mini" placeholder="输入需要座位牌的具体安排、人员"
                  v-model="form2.seat"></el-input>
              </div>
              <div class="clear" style="margin-top:10px;">
                <el-input type="textarea" v-model="form2.remark" placeholder="您可以输入更多需要的会议准备"></el-input>
              </div>

              <div class="contact-user-list" style="margin-top:5px;">
                <div class="user-item" v-for="user,i in selectPlanArr">
                  <span class="name">{{user.name}}</span>
                  <span @click="deleteUsers(2,i)" class="iconfont icon-close1"></span>
                </div>
              </div>
              <el-button size="small" @click="addUsers(2)" type="primary">选择会议准备推送人</el-button>
            </div>
          </el-form-item>
          <el-form-item label="会议通知">
            <el-checkbox v-model="form.isWx">企业微信通知</el-checkbox>
            <el-checkbox v-model="form.isSms">短信通知</el-checkbox>
          </el-form-item>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="editMeeting()" class="form-btn" type="success">确认修改会议</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Attachments from '@/components/Attachments'
  export default {
    components: {
      Attachments
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    data() {
      return {
        organizationListData: [],
        meetingRoomData: [],

        // 会议form
        form: {
          conferenceId: "",
          depId: "",
          name: "",
          roomId: "",
          conferenceTime: "",
          useTime: "",
          userIds: "",
          req: "",
          isWx: true,
          isSms: false
        },

        // 会议准备form
        isForm2: false,
        form2: {
          conferenceApplyId: "",
          conferenceId: "",
          isHaveCamera: false,
          isHaveEat: false,
          isHaveProjector: false,
          isHaveSeat: false,
          isHaveTea: false,
          seat: "",
          remark: "",
          userId: "",
        },

        firstLoading: true,
        meetingData: {},
        attachmentArr: [],
        selectArr: [],

        // 1: 参会  2：准备
        selectType: 1,
        // 参会人员
        selectArr: [],
        // 会议准备人员
        selectPlanArr: [],

        formLoading: false,
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.form.conferenceId = this.$route.params.id
      // this.form.conferenceApplyId = this.$route.params.id


      this.getMeeting()
    },
    methods: {
      // 会议准备
      meetingPlan(id, cb) {
        if (this.isForm2) {
          this.form2.conferenceId = id
          if (this.selectPlanArr[0]) {
            this.form2.userId = this.selectPlanArr[0].id
          } else {
            this.$message.error("您勾选了会议准备，但未勾选会议准备的通知人，请先勾选会议准备推送人~")
            return
          }
          ajax.post('/conference/plan/add', this.form2, (res) => {
            cb && cb()
          })
        } else {
          if (this.meetingData.conferencePlan) {
            // 删除原会议准备
            ajax.post('/conference/plan/del', {
              conferenceId: id
            }, (res) => {
              cb && cb()
            })
          } else {
            cb && cb()
          }
        }
      },
      // 编辑会议
      editMeeting() {
        this.form.userIds = this.selectArr.map(item => item.id).join()
        if (!this.form.depId || !this.form.name || !this.form.roomId || !this.form.conferenceTime || !this.form
          .userIds) {
          this.$message.error('会议所有项目均是必填项')
          return
        }

        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        ajax.post('/conference/edit', this.form, (res) => {
          this.formLoading = false

          // 会议准备
          this.meetingPlan(res.vo.id, () => {
            this.$message.success("修改会议成功")
            this.$router.back()
          })
        })
      },

      deleteUsers(type, index) {
        if (type == 1) {
          this.selectArr.splice(index, 1)
        } else {
          this.selectPlanArr.splice(index, 1)
        }
      },
      // 添加参会人员
      addUsers(type) {
        this.selectType = type

        let _sr = []
        switch (type) {
          case 1:
            _sr = this.selectArr
            break;
          case 2:
            _sr = this.selectPlanArr
            break;
        }
        this.$store.commit('set_contactSelectArr', _sr)

        this.$store.commit('set_contactShow', true)
        if (this.selectType == 1) {
          this.$store.commit('set_contactSingleSelect', false)
        } else {
          this.$store.commit('set_contactSingleSelect', true)
        }
      },
      getMeetingRoom() {
        ajax.post('/conference/room/list', {
          'depId': this.form.depId
        }, (res) => {
          this.meetingRoomData = res.vo.array
          this.firstLoading = false
        })
      },
      getMeeting() {
        ajax.get('/conference/detail/' + this.form.conferenceId, '', (res) => {
          this.meetingData = res.vo
          this.form.depId = this.meetingData.depId
          this.form.name = this.meetingData.name
          this.form.roomId = this.meetingData.roomId
          this.form.conferenceTime = this.meetingData.conferenceTime
          this.form.useTime = this.meetingData.useTime
          this.form.req = this.meetingData.req
          this.form.isWx = this.meetingData.isWx
          this.form.isSms = this.meetingData.isSms



          this.isForm2 = this.meetingData.conferencePlan ? true : false
          if (this.isForm2) {
            this.form2 = this.meetingData.conferencePlan
            this.form2.conferenceApplyId = this.meetingData.conferenceApplyId
            this.selectPlanArr.push(this.meetingData.conferencePlan.receiver)
          }

          this.attachmentArr = this.meetingData.attachments ? this.meetingData.attachments : []
          this.selectArr = this.meetingData.joinUsers
        })
      },
    },
    watch: {
      contactSelectArr() {
        if (this.selectType == 1) {
          this.selectArr = this.contactSelectArr
        } else {
          this.selectPlanArr = this.contactSelectArr
        }
      },
      'form.depId'() {
        if (!this.firstLoading) {
          this.form.roomId = ""
        }
        this.getMeetingRoom()
      },
    },
    // beforeRouteLeave(to, from, next) {
    //   next()
    // },
  };

</script>



// WEBPACK FOOTER //
// src/page/meeting/edit.vue